import React, { useContext, useEffect, useState } from "react";
import TableHeader from "../Utility/TableHeader";
import {
  ChatBubbleLeftEllipsisIcon,
  EyeIcon,
  PencilSquareIcon,
} from "@heroicons/react/24/outline";
import DeleteConfirmation from "../Utility/DeleteConfirmation";
import axios from "axios";

import LeadDiscusstion from "./LeadDiscusstion";
import { Pagination } from "../../helper/HelperTwo";
import { Tooltip } from "react-tooltip";

function AllLeadTaskList({
  setOpenDialogBoxForLead,
  setLeadDetails,
  setSaveBtn,
  setLoading,
  allPaginationTaskDatas,
  allTaskDatas,
  setLeadTaskDetails,
  setLeadTaskFile,
  setEditId,
  setLeadType,
  fetchLeadTaskDatas,
  setIsEditing,
  setEditTaskIdCrypt,
  setSaveBtnOpen,
  id_crypt,
  showForm,
  taskFilterParams
}) {
  const userForView = JSON.parse(localStorage.getItem("user"));
  const taskPermissionForView = userForView?.task_role_based_access?.some(
    (access) => access.label_id == 6 && access.label_value != 0
  );

  const userForDelete = JSON.parse(localStorage.getItem("user"));
  const taskPermissionForDelete = userForDelete?.task_role_based_access?.some(
    (access) => access.label_id == 4 && access.label_value != 0
  );

  const userForDiscussion = JSON.parse(localStorage.getItem("user"));
  const taskPermissionForDiscussion =
    userForDiscussion?.task_role_based_access?.some(
      (access) => access.label_id == 5 && access.label_value != 0
    );

  const headers = [
    "S No",
    "Task Name",
    "Task Type",
    "Lead Name",
    "Priority",
    "Task Status",
    "Task Members",
    // "Source",
    // "Status",
    // "Created By",
    "Action",
  ];
  const [currentPage, setCurrentPage] = useState(1);

  const currentLoginIdForAdmin = parseInt(localStorage.getItem("role_id"), 10); //current login oda user_id 1 ah irundha ? ella datas um show panrom
  console.log(currentLoginIdForAdmin,"jiii");
  
  const adminId = localStorage.getItem("role_id");
  const currentLoginIdForEmployee = JSON.parse(localStorage.getItem("user"))
    ?.employee?.id; // current login oda user la iruka employee oda id namba task la iruka task_member la iruka id oda match aachu apdina and employee oda tasks matum  list out panrom

  const filteredTasks =
    currentLoginIdForAdmin == 1
      ? allPaginationTaskDatas?.data || []
      : (allPaginationTaskDatas?.data || []).filter((task) =>
          task.task_member.some(
            (member) =>
              parseInt(member.id, 10) === parseInt(currentLoginIdForEmployee)
          )
        );

  // const filteredTasks =
  //   currentLoginIdForAdmin === 1
  //     ? allTaskDatas || []
  //     : (allTaskDatas || []).filter((task) =>
  //         task.task_member.some(
  //           (member) =>
  //             parseInt(member.id, 10) === parseInt(currentLoginIdForEmployee)
  //         )
  //       );

 

  const [leadDiscusstion, setLeadDiscusstion] = useState(false);

  const handleViewForLead = async (id_crypt) => {
    // setLoading(true);
    setIsEditing(true);
    setOpenDialogBoxForLead(true);
    setEditTaskIdCrypt(id_crypt);
    setSaveBtnOpen(false);
    setEditId(id_crypt);
    try {
      const response = await axios.get(
        `public/api/admin/tasks/edit/${id_crypt}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      
      const task = response.data.task;

      if (task.task_type === "1") {
        setLeadType("general");
      } else {
        setLeadType("lead");
      }

      setLeadTaskDetails({
        task_type: task.task_type,
        lead_id: task.lead_name?.id, // Corrected: Use `task.lead_id` directly
        leads: task.lead_name?.id || "",  // Convert string to number
        task_name: task.task_name,
        task_status: task.task_status,
        task_members: task.task_member.map((item) => item.id),
        priority: task.priority,
        start_date: task.start_date,
        end_date: task.end_date,
        task_description: task.task_description,
      });
      setLeadTaskFile(response?.data?.task?.task_files);
    } catch (error) {
      // toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (showForm && id_crypt) {
      handleViewForLead(id_crypt);
    }
  }, [showForm, id_crypt]);


  const handlePageChange = (page) => {
    if (page !== "..." && !isNaN(page)) {
      const newPage = Number(page);
      setCurrentPage(newPage);
      fetchLeadTaskDatas(newPage,taskFilterParams);
    }
  };

  return (
    <>
      <div className="overflow-x-auto mt-8">
        <table className="min-w-full divide-y divide-gray-300">
          <TableHeader headers={headers} />

          <tbody className="divide-y divide-gray-200 bg-white">
            {filteredTasks && filteredTasks?.length > 0 ? (
              filteredTasks?.map((lead, index) => (
                <tr
                  key={index}
                  className="hover:bg-gray-50 transition duration-300 ease-in-out"
                >
                  <td className="whitespace-nowrap text-md uppercase sm:pl-4 text-center">
                    {allPaginationTaskDatas.from + index}
                  </td>
                  <td className="whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center">
                    {lead.task_name}
                  </td>
                  <td
                    className={`whitespace-nowrap text-md text-gray-500  sm:pl-4 text-center ${
                      lead.task_type === "1"
                        ? "text-blue-500"
                        : "text-green-500"
                    }`}
                  >
                    {lead.task_type == 1 ? "General" : "Lead"}
                  </td>
                  <td
                    className={`whitespace-nowrap text-md text-gray-500  text-center sm:pl-4`}
                  >
                    {lead.lead_name?.name || "Other"}
                  </td>
                  <td className="whitespace-nowrap text-md text-gray-500  sm:pl-4 text-center">
                    {lead.priority_name?.name}
                  </td>
                  <td className="whitespace-nowrap text-md text-gray-500  sm:pl-4 text-center">
                    <span
                      className={`border rounded px-2 py-1 ${
                        lead.task_status_name?.name === "Pending"
                          ? "border-blue-600 text-blue-600"
                          : lead.task_status_name?.name === "Completed"
                          ? "border-green-600 text-green-600"
                          : lead.task_status_name?.name === "Not Yet Started"
                          ? "border-red-500 text-red-500"
                          : lead.task_status_name?.name === "In Progress"
                          ? "border-purple-600 text-purple-600"
                          : "border-gray-400 text-gray-600"
                      }`}
                    >
                      {lead.task_status_name?.name}
                    </span>
                  </td>
                  <td className="whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center tracking-normal">
                    {lead.task_member?.map((item) => item.name).join(", ")}
                  </td>
                  <td className="flex space-x-2 items-center justify-center py-4 text-center text-sm text-gray-500 font-semibold">
                    {taskPermissionForDiscussion && (
                      <LeadDiscusstion
                        id_crypt={lead.id_crypt}
                        leadId={lead.id}
                        setLeadDiscusstion={setLeadDiscusstion}
                      />
                    )}

                    {taskPermissionForView && (
                      <span
                        className="my-anchor-view relative group cursor-pointer bg-blue-400 rounded-md p-1"
                        onClick={() => handleViewForLead(lead.id_crypt)}
                      >
                        <EyeIcon className="h-5 w-5 text-white" />
                        <Tooltip
                          anchorSelect=".my-anchor-view"
                          place="top"
                          className="text-xs p-0"
                          style={{ fontSize: "12px", padding: "0.3rem" }}
                        >
                          View
                        </Tooltip>
                      </span>
                    )}

                    {taskPermissionForDelete && (
                      <DeleteConfirmation
                        id_crypt={lead.id_crypt}
                        apiType="lead_task"
                        fetchClientData={fetchLeadTaskDatas}
                      />
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} className="text-center">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>

          {/* </tbody> */}
        </table>
      </div>

      {/* <LeadDiscusstion setLeadDiscusstion={setLeadDiscusstion} leadDiscusstion={leadDiscusstion} idCryptForDiscussion={idCryptForDiscussion} /> */}

      {filteredTasks?.length > 0 ? (
        <Pagination
          links={allPaginationTaskDatas.links} // Keep original links for navigation
          currentPage={allPaginationTaskDatas.current_page}
          totalResults={filteredTasks.length} // Update total results based on filtered data
          from={filteredTasks.length > 0 ? 1 : 0} // Start from 1 if there are results
          to={filteredTasks.length} // Show the total count as the last item
          lastPage={Math.ceil(
            filteredTasks.length / (allPaginationTaskDatas.per_page || 10)
          )} // Calculate last page dynamically
          onPageChange={handlePageChange}
        />
      ) : (
        allPaginationTaskDatas && (
          <Pagination
            links={allPaginationTaskDatas.links}
            currentPage={allPaginationTaskDatas.current_page}
            totalResults={allPaginationTaskDatas.total}
            from={allPaginationTaskDatas.from}
            to={allPaginationTaskDatas.to}
            lastPage={allPaginationTaskDatas.last_page}
            onPageChange={handlePageChange}
          />
        )
      )}
    </>
  );
}

export default AllLeadTaskList;
